/* HTTP取消的统一申请 */

import axios, { AxiosRequestConfig, AxiosResponse, CancelToken, Canceler } from 'axios'

interface IPendingRequest {
  id: string;
  cancel: Canceler;
}

const pendingRequests: IPendingRequest[] = []

export const RemovePendingRequest = (config: AxiosRequestConfig) => {
  pendingRequests.forEach((request, idx) => {
    if (request.id === config.url + '&' + config.method) {
      request.cancel()
      pendingRequests.splice(idx, 1)
    }
  })
}

export const AddPendingRequest = (config: AxiosRequestConfig): CancelToken => {
  return new axios.CancelToken(c => {
    pendingRequests.push({ id: config.url + '&' + config.method, cancel: c })
  })
}
